import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { ReactComponent as UploadIcon } from 'svg/fi_upload.svg'
interface localImageUploadProps {
  handleButtonClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  index: number
  isPending: boolean
  className?: string
  label?: string
}
export const LocalImageUpload = ({
  handleButtonClick,
  index,
  isPending,
  className,
  label,
}: PropsWithChildren<localImageUploadProps>) => {
  return (
    <button
      className={classNames(
        className ||
          'w-[85px] h-[151px] flex items-center justify-center bg-white rounded-[4px] flex-col gap-[10px] text-[#8F929B] hover:bg-gray-200'
      )}
      type="button"
      onClick={handleButtonClick}
    >
      <>
        <UploadIcon />
        <span className="text-[12px]">
          {label ? label : '이미지'}
          {` `}업로드
        </span>
      </>
    </button>
  )
}
